/**
 * Service Times block — structured by day + time with full location.
 */
import { Trash2, Plus, Clock } from "lucide-react";

const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const inp = "w-full bg-black border border-white/15 focus:border-[#D4AF37] outline-none px-3 py-2.5 rounded text-sm text-white";

const newRow = () => ({
  name: "",
  day_of_week: "Sunday",
  start_time: "10:00",
  end_time: "12:00",
  venue_name: "",
  address_line1: "",
  city: "",
  postcode: "",
  maps_url: "",
});

export default function ServiceTimesEditor({ items = [], onChange }) {
  const update = (i, patch) => {
    const arr = [...items];
    arr[i] = { ...arr[i], ...patch };
    onChange(arr);
  };
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
  const add = () => onChange([...items, newRow()]);

  return (
    <div data-testid="block-service-times" className="luxury-card rounded-xl p-5">
      <div className="flex items-center justify-between">
        <div className="font-serif-display text-xl flex items-center gap-2"><Clock size={16} className="text-[#D4AF37]" /> Service Times</div>
        <button data-testid="block-st-add" onClick={add} className="btn-ghost-gold text-[10px] tracking-widest uppercase px-3 py-1.5 rounded inline-flex items-center gap-1"><Plus size={11} /> Add Service</button>
      </div>
      <div className="mt-4 space-y-3">
        {items.map((row, i) => (
          <div key={i} className="border border-white/5 rounded-lg p-3 bg-black/30 space-y-2">
            <div className="grid sm:grid-cols-2 gap-2">
              <input className={inp} placeholder="Service name (e.g. Sunday Worship)" value={row.name || ""} onChange={(e) => update(i, { name: e.target.value })} data-testid={`st-${i}-name`} />
              <select className={inp} value={row.day_of_week || "Sunday"} onChange={(e) => update(i, { day_of_week: e.target.value })} data-testid={`st-${i}-day`}>
                {DAYS.map((d) => <option key={d}>{d}</option>)}
              </select>
            </div>
            <div className="grid sm:grid-cols-2 gap-2">
              <input className={inp} type="time" value={row.start_time || ""} onChange={(e) => update(i, { start_time: e.target.value })} data-testid={`st-${i}-start`} />
              <input className={inp} type="time" value={row.end_time || ""} onChange={(e) => update(i, { end_time: e.target.value })} data-testid={`st-${i}-end`} />
            </div>
            <input className={inp} placeholder="Venue name (optional)" value={row.venue_name || ""} onChange={(e) => update(i, { venue_name: e.target.value })} />
            <div className="grid sm:grid-cols-3 gap-2">
              <input className={inp} placeholder="Address" value={row.address_line1 || ""} onChange={(e) => update(i, { address_line1: e.target.value })} />
              <input className={inp} placeholder="City" value={row.city || ""} onChange={(e) => update(i, { city: e.target.value })} />
              <input className={inp} placeholder="Postcode" value={row.postcode || ""} onChange={(e) => update(i, { postcode: e.target.value })} />
            </div>
            <input className={inp} placeholder="Google Maps link (optional)" value={row.maps_url || ""} onChange={(e) => update(i, { maps_url: e.target.value })} />
            <button data-testid={`st-${i}-remove`} onClick={() => remove(i)} className="text-red-400 text-xs tracking-widest uppercase inline-flex items-center gap-1"><Trash2 size={11} /> Remove</button>
          </div>
        ))}
        {items.length === 0 && <div className="text-xs text-neutral-500">No service times yet.</div>}
      </div>
    </div>
  );
}
